import Repository from "./Repository";

const classes = "/classes";

export default {
  getClasses: (params) => Repository.get(`${classes}/`, { params: params }),
  getTeachers: () => Repository.get(`${classes}/teachers/`),
  getClass: (id) => Repository.get(`${classes}/${id}/`),
  getClassWithHomeworks: (id, payload) =>
    Repository.get(`${classes}/${id}/retrieve_with_homeworks/`, {
      params: payload,
    }),
  createClass: (myClass) => Repository.post(`${classes}/`, myClass),
  editClass: (id, myClass) => Repository.patch(`${classes}/${id}/`, myClass),
  teacherJoinsClass: (id) =>
    Repository.patch(`${classes}/${id}/teacher_joins_class/`),
  deleteStudentClass: (id, studentId) =>
    Repository.delete(`${classes}/${id}/student/${studentId}/`),
  deleteClass: (id) => Repository.delete(`${classes}/${id}/`),
};
